(function () {
  var data = window.__rspData;
  if (!data || !data.products || !data.products.length) return;

  var container = document.getElementById('recent-sales-popup');
  if (!container) return;

  var FIRST_DELAY = 7000;
  var BETWEEN_DELAY_MIN = 7000;
  var BETWEEN_DELAY_MAX = 10000;
  var VISIBLE_FOR = 5500;
  var STORAGE_KEY = 'rsp_dismissed';

  if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function randomAgo() {
    var useHours = Math.random() < 0.15;
    if (useHours) {
      var h = 1 + Math.floor(Math.random() * 4);
      return h + ' ' + data.i18n.unitHours;
    }
    var m = pick(data.times);
    return m + ' ' + data.i18n.unitMinutes;
  }

  function buildToast() {
    var name = pick(data.names);
    var city = pick(data.cities);
    var ago = randomAgo();
    var product = pick(data.products);
    var boughtText = data.i18n.bought.replace('{city}', city);

    var toast = document.createElement('div');
    toast.className = 'rsp-toast color-accent-1 gradient';
    toast.innerHTML =
      '<img src="' + product.image + '" alt="" loading="lazy" width="36" height="36">' +
      '<div class="rsp-body">' +
      '<span><strong>' + name + '</strong> ' + boughtText + '</span>' +
      '<span class="rsp-product">' + product.title + '</span>' +
      '<span class="rsp-price-row">' +
      '<span class="rsp-price">' + product.price + '</span>' +
      '<span class="rsp-badge">' + data.i18n.badge + '</span>' +
      '</span>' +
      '<span class="rsp-meta">' + ago + '</span>' +
      '</div>' +
      '<button type="button" class="rsp-close" aria-label="Close">&times;</button>';

    toast.addEventListener('click', function (e) {
      if (e.target.classList.contains('rsp-close')) {
        sessionStorage.setItem(STORAGE_KEY, '1');
        hide(toast);
        return;
      }
      window.location.href = product.url;
    });

    return toast;
  }

  function hide(toast) {
    toast.classList.remove('rsp-show');
    setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 350);
  }

  function showNext() {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
    container.innerHTML = '';
    var toast = buildToast();
    container.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('rsp-show');
    });
    setTimeout(function () {
      hide(toast);
    }, VISIBLE_FOR);
  }

  function scheduleNext() {
    var between = BETWEEN_DELAY_MIN + Math.random() * (BETWEEN_DELAY_MAX - BETWEEN_DELAY_MIN);
    setTimeout(function () {
      showNext();
      scheduleNext();
    }, between + VISIBLE_FOR);
  }

  setTimeout(function () {
    showNext();
    scheduleNext();
  }, FIRST_DELAY);
})();
